module.exports = __webpack_public_path__ + "img/knewidea1.07510e62.png";